import React from 'react';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Alert, Box, Link, Stack, Typography } from '@mui/material';
import {
  DIGITAL_HEALTH_MHR_ACCESS_URL,
  DIGITAL_HEALTH_MHR_RESTRICT_ACCESS_URL,
  DIGITAL_HEALTH_URL,
} from './EnableMHRAccessModal.constants.ts';

export const MHRInformationSection: React.FC = () => (
  <Stack gap={1}>
    <Typography variant="body1">
      To allow us access to your My Health Record, you'll need to generate an access code. Instructions to create your
      access code are provided below.
    </Typography>

    <Box>
      <Alert severity="info" icon={false}>
        More information can be found on the{' '}
        <Link href={DIGITAL_HEALTH_URL} target="_blank" rel="noopener">
          Digital Health Australia
        </Link>{' '}
        website.
        <ul style={{ padding: 0, paddingLeft: '1.5rem', margin: 0 }}>
          <li>
            <Link
              href={DIGITAL_HEALTH_MHR_ACCESS_URL}
              target="_blank"
              rel="noopener"
              variant="caption"
              sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}
            >
              Learn more about accessing your My Health Record
              <OpenInNewIcon fontSize="inherit" />
            </Link>
          </li>
          <li>
            <Link
              href={DIGITAL_HEALTH_MHR_RESTRICT_ACCESS_URL}
              target="_blank"
              rel="noopener"
              variant="caption"
              sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}
            >
              Learn more about restricting access to your My Health Record access
              <OpenInNewIcon fontSize="inherit" />
            </Link>
          </li>
        </ul>
      </Alert>
    </Box>
  </Stack>
);
